import React from 'react';
import { IfmsRoute }from '../../../config/types';

export const CompanyView = React.lazy(() => import('../companies/CompanyView'));
const JobListView = React.lazy(() => import('../JobListView'));
const ReportViewer2 = React.lazy(() => import('../../../uiControls/ReportViewer2'));

const AgentStatementView = React.lazy(() => import('../../accounting/reports/AgentStatementView'));
const CustomerVendorViews = React.lazy(() => import('../../accounting/reports/CustomerVendorStatementView'));
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView')); 
const ImporterBondQueryView = React.lazy(() => import('../../referenceFiles/implementation/codes/ImporterBondQueryView'));
const LastTransactionView = React.lazy(() => import('../../referenceFiles/implementation/codes/LastTransactionView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView'));
const CompanyAddressLabelView = React.lazy(() => import('../../reports/CompanyAddressLabelView'));
const CustomerActivityView =  React.lazy(() => import('../../common/reports/CustomerActivityView'));
const InternetTrackingCustomerView = React.lazy(() => import('../../referenceFiles/implementation/codes/InternetTrackingCustomerView'));
const DeleteHistoryView = React.lazy(() => import('../../common/DeleteHistoryView'));

const routes:Array<IfmsRoute> = [
  {path: '/common/companies/:mode/:id?/:createEntity?', component: CompanyView},
  // jobName (JobNames), opType (constants.opTypes)
  {path: '/common/joblistview/:jobName/:opType?', component: JobListView},
  //<pt220406: optab-rptviewer: Originating opType to show op menu (ifmsMain.operationFactory가 path에서 /opType을 찾는다)>
  {path: '/common/report/:args/:opType?', component: ReportViewer2},
  {path: '/common/deleteHistory', component: DeleteHistoryView},
  
  {path: '/company/agentStatement', component: AgentStatementView},
  {path: '/company/customerVendor', component: CustomerVendorViews},
  {path: '/company/pickupDelivery', component: PickupDeliveryView},
  {path: '/company/importerBondQuery', component: ImporterBondQueryView},
  {path: '/company/lastTransaction', component: LastTransactionView},
  {path: '/company/memoList', component: MemoListView},
  {path: '/company/companyAddressLabel', component: CompanyAddressLabelView},
  {path: '/company/activeCustomer', component: CustomerActivityView},
  {path: '/company/internetTrackingCustomers', component: InternetTrackingCustomerView},
];

export default routes;
